/* eslint-disable func-names */
import * as Yup from 'yup';

import { isValidUrl } from 'common-validator-fif-payments';

import { EVENTS_WEBHOOKS } from '@constants/credential';
import { store } from '@store/store';

Yup.addMethod(Yup.string, 'validUrl', function (errorMessage) {
  return this.test(`test-card-length`, errorMessage, function (value) {
    const { sub_domains: subDomains } = store.getState().config;
    if (!value) return true;
    const { path, createError } = this;
    return isValidUrl(value, { subDomains }) || createError({ path, message: errorMessage });
  });
});

const validationsWebhooks = EVENTS_WEBHOOKS.reduce(
  (resume, key) => ({ ...resume, [key]: Yup.string().validUrl('errors.url.valid') }),
  {}
);

export default validationsWebhooks;
